import React, { Component } from 'react';
import './index.scss';
import { Statistic, Avatar, Row, Col, Typography, Card, Badge, Button, DatePicker, Empty, message, Tooltip, Tag, Table, Descriptions } from 'antd';
import { UserOutlined, MailOutlined } from '@ant-design/icons';
import { TeamOutlined } from '@ant-design/icons';
import CountUp from 'react-countup';
import stc from 'string-to-color';
import moment from 'moment';
import BayHistogram, { ConsistencyDial } from '../../components/LiveShoots/BayHistogram';
import OperatorBreaks from '../../components/LiveShoots/OperatorBreaks';

const formatter = value => <CountUp end={value} separator="," duration={1} />;

const CountStats = ({ completedDetails, isGetSessionFeching, isSessionFetching }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
                gap: '3%',
                flexWrap: 'wrap',
                padding: '0 1rem',
                backgroundColor: '#FFF4E0',
                borderRadius: '15px',
            }}
        >
            {completedDetails?.map((item, key) => (
                <Statistic
                    key={key}
                    title={item?.productType || '-'}
                    value={item?.count || ''}
                    formatter={formatter}
                    loading={isGetSessionFeching || isSessionFetching}
                    style={{
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                    }}
                />
            ))}
        </div>
    );
};

export default function LiveDataView({ session, index, isFetching, completionLabel, completionKind }) {
    return (
        <div
            className="container"
            style={{
                border: `1px dashed ${stc(session?.sessionId)}`,
                boxShadow: `5px 5px 10px ${stc(session?.sessionId)}`,
            }}
            key={index}
        >
            <Row className="detailsContainer" style={{ color: stc(session?.sessionId) }} gutter={[4, 4]}>
                <Col span={8} className="overflow_wrap">
                    <i>Date : </i>
                    <b>{`${new Date(session?.date).toLocaleDateString('en-GB', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                    })}`}</b>
                </Col>
                <Col span={10} className="overflow_wrap">
                    <i>SessionId : </i>
                    <b>{`${session?.sessionId}`}</b>
                </Col>
                <Col span={6} className="overflow_wrap">
                    <i>Total Count: </i>
                    <b>{`${session?.skusCount}`}</b>
                </Col>
            </Row>
            <Row className="detailsContainer" style={{ color: stc(session?.sessionId) }} gutter={[4, 4]}>
                {session?.users?.map(item => {
                    return (
                        <Col span={24} style={{ display: 'flex' }}>
                            <Col span={9} className="overflow_wrap">
                                <UserOutlined />
                                {'  '} <b>{`${item?.name}`}</b>
                            </Col>
                            <Col span={1} className="overflow_wrap">
                                :
                            </Col>
                            <Col span={14} className="overflow_wrap">
                                <MailOutlined />
                                {'  '}
                                <b>{`${item?.email}`}</b>
                            </Col>
                        </Col>
                    );
                })}
            </Row>
            {session?.SkuStats?.length > 0 ? (
                <Row className="stats_count_container" gutter={[5, 5]}>
                    <CountStats completedDetails={session?.SkuStats} isGetSessionFeching={isFetching} isSessionFetching={false} />
                </Row>
            ) : null}
            {session?.performance ? (
                <div className="shift-performance">
                    <div>
                        <div className="shift-label">Consistency</div>
                        <ConsistencyDial score={session.performance.consistency} />
                    </div>
                    <BayHistogram
                        histogram={session.performance.histogram}
                        kinds={[{ key: completionKind, label: completionLabel, color: '#12b76a' }]}
                        emptyText="No completions in this shift"
                        timeZone="Europe/Berlin"
                        zoneLabel="CET"
                    />
                </div>
            ) : null}
            <OperatorBreaks operators={session?.performance?.operators} />
            <Row className="bottom-row">
                <div className="session-alive">
                    {session?.isSessionAlive ? (
                        <Tooltip title="Active Session">
                            <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#79D70F' }}></div>
                        </Tooltip>
                    ) : (
                        <Tooltip title="InActive Session">
                            <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'red' }}></div>
                        </Tooltip>
                    )}
                </div>
            </Row>
        </div>
    );
}

// <>
//     <div className="container-liveData">
//         <div className="session-details-container">
//             <Statistic title="Date" value={session?.date} />
//             <Statistic title="Session ID" value={session?.sessionId} />
//             <Statistic title="Total Count" value={session?.skusCount} />
//         </div>
//         <br />
//         <hr />
//         <br />
//         <div className="user-wrapper">
//             <Descriptions className="user-details" title="User Details" bordered size="small" layout="horizontal">
//                 {session?.users?.map(item => {
//                     const { email, name } = item;
//                     return (
//                         <Descriptions.Item
//                             contentStyle={{
//                                 textAlign: 'center',
//                             }}
//                             labelStyle={{
//                                 backgroundColor: 'gray',
//                                 color: 'white',
//                                 borderRadius: '8px',
//                                 textAlign: 'center',
//                             }}
//                             label={name}
//                         >
//                             {email}
//                         </Descriptions.Item>
//                     );
//                 })}
//             </Descriptions>
//             <Descriptions className="product-details" title="Product Details" bordered size="small" layout="vertical">
//                 {session?.SkuStats?.map(item => {
//                     const { productType, count } = item;
//                     return <Descriptions.Item label={productType}>{count}</Descriptions.Item>;
//                 })}
//             </Descriptions>
//         </div>
//     </div>
// </>
